import script from "./UserKycForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserKycForm.vue?vue&type=script&setup=true&lang=ts"

import "./UserKycForm.vue?vue&type=style&index=0&id=1696fdec&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1696fdec"]])

export default __exports__